function ExtensionCardFooter({children}) {
  return (
      <div className="absolute bottom-0 left-0 bg-gray/50 px-4 py-2 w-full h-9 rounded-b-15">{children}</div>
  );
}

export default ExtensionCardFooter;